import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { XCircle } from 'lucide-react';
import api from '../utils/api';

// Cible du lien envoyé par email : /reinitialiser-mot-de-passe?token=...
export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get('token');
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);

  if (!token) {
    return (
      <div className="auth-page">
        <div className="auth-card card" style={{ textAlign: 'center' }}>
          <XCircle size={44} color="#dc2626" style={{ margin: '0 auto 14px' }} />
          <h2 style={{ marginBottom: 10 }}>Lien invalide</h2>
          <p style={{ color: 'var(--text-light)' }}>
            Ce lien de réinitialisation est incomplet.
          </p>
          <p style={{ marginTop: 18, fontSize: '0.9rem' }}>
            <Link to="/mot-de-passe-oublie">Demander un nouveau lien</Link>
          </p>
        </div>
      </div>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) return toast.error('Les mots de passe ne correspondent pas');
    if (password.length < 8) return toast.error('8 caractères minimum');
    setLoading(true);
    try {
      const { data } = await api.post('/auth/reset-password', { token, password });
      toast.success(data.message);
      navigate('/login');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Erreur, réessayez');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card card">
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <h2 style={{ margin: 0 }}>Nouveau mot de passe</h2>
          <p className="auth-subtitle">Choisissez un mot de passe d'au moins 8 caractères</p>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Nouveau mot de passe</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)}
              required minLength={8} autoFocus />
          </div>
          <div className="form-group">
            <label>Confirmer</label>
            <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)}
              required minLength={8} />
          </div>
          <button className="btn btn-primary" style={{ width: '100%', marginTop: 8 }} disabled={loading}>
            {loading ? 'Enregistrement...' : 'Réinitialiser le mot de passe'}
          </button>
        </form>
      </div>
    </div>
  );
}
